import React, { useState, useEffect } from "react";
import axios from "axios";
import logo from "../../src/assets/logo-IRC.png";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./login.css";
import Cookies from "js-cookie";
import { logout } from "./Logout";
import { getNodeApiBase } from "../utils/apiBase";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const nodeApiBase = getNodeApiBase();

  useEffect(() => {
    if (location.state?.passwordResetSuccess) {
      toast.success("Votre mot de passe a été réinitialisé avec succès. Vous pouvez vous connecter.");
      navigate("/login", { replace: true, state: {} });
    }
  }, [location, navigate]);

  const doLogin = async (e) => {
    e.preventDefault();

    try {
      // Use environment variable with a fallback URL
      const baseUrl = process.env.REACT_APP_BASE_URL;

      // Log the base URL to debug
      console.log("Base URL:", baseUrl);

      // Perform the POST request
      const response = await axios.post(`${baseUrl}/login.php`, {
        email: email,
        password: password,
      });

      if (
        response.data.role === "evaluateur" ||
        response.data.role === "chercheur" ||
        response.data.role === "administrateur"
      ) {
        Cookies.set("email", email, { expires: 30, path: "/" });

        // Helper: fuzzy id extraction from arbitrary response keys
        const findIdByFuzzy = (obj, part) => {
          try {
            for (const [k, v] of Object.entries(obj || {})) {
              if (typeof k !== "string") continue;
              const key = k.toLowerCase();
              if (!key.includes(part)) continue;
              if (typeof v === "number") return String(v);
              if (typeof v === "string" && /^\d+$/.test(v)) return v;
            }
          } catch {}
          return null;
        };

        // Normalize backend keys for idevaluateur/idchercheur (with fuzzy fallback)
        let idevaluateurResp =
          response?.data?.idevaluateur ??
          response?.data?.idevaluteur ??
          response?.data?.id_evaluateur ??
          response?.data?.idEvaluateur ??
          response?.data?.evaluateur_id ??
          findIdByFuzzy(response?.data, "evalu");

        let idchercheurResp =
          response?.data?.idchercheur ??
          response?.data?.id_chercheur ??
          response?.data?.idChercheur ??
          findIdByFuzzy(response?.data, "cherch");

        if (idevaluateurResp) {
          Cookies.set("idevaluateur", String(idevaluateurResp), {
            expires: 30,
            path: "/",
          });
          // Backward compatibility: also set legacy cookie name if other code still reads it
          Cookies.set("idevaluteur", String(idevaluateurResp), {
            expires: 30,
            path: "/",
          });
        }
        if (idchercheurResp) {
          Cookies.set("idchercheur", String(idchercheurResp), {
            expires: 30,
            path: "/",
          });
        }

        // Optional: lightweight fallback lookups by email if an id is still missing
        try {
          if (!idchercheurResp && email) {
            const resC = await axios.get(`${nodeApiBase}/api/chercheurs/by-email`, {
              params: { email },
            });
            const altC =
              resC?.data?.idchercheur ??
              resC?.data?.id_chercheur ??
              resC?.data?.id ??
              findIdByFuzzy(resC?.data, "cherch");
            if (altC) {
              idchercheurResp = String(altC);
              Cookies.set("idchercheur", idchercheurResp, { expires: 30, path: "/" });
            }
          }
          if (!idevaluateurResp && email) {
            const resE = await axios.get(`${nodeApiBase}/api/evaluteurs/by-email`, {
              params: { email },
            });
            const altE =
              resE?.data?.idevaluateur ??
              resE?.data?.id_evaluateur ??
              resE?.data?.id ??
              findIdByFuzzy(resE?.data, "evalu");
            if (altE) {
              idevaluateurResp = String(altE);
              Cookies.set("idevaluateur", idevaluateurResp, { expires: 30, path: "/" });
              Cookies.set("idevaluteur", idevaluateurResp, { expires: 30, path: "/" });
            }
          }
        } catch (e) {
          console.warn("ID fallback lookup skipped:", e?.message || e);
        }

        console.log("Extracted ids:", {
          role: response.data.role,
          idevaluateur: idevaluateurResp,
          idchercheur: idchercheurResp,
        });

        // Check if chercheur is also an evaluateur (returned by PHP login directly)
        if (response.data.is_also_evaluateur === true) {
          navigate("/select-profile");
          return;
        }

        // Log using normalized values instead of raw response keys
  console.log("idchercheur", idchercheurResp, "idevaluateur", idevaluateurResp);

        console.log("Login successful", response.data);

        if (response.data.role === "evaluateur") {
          navigate("/select-profile");
        } else {
          navigate("/home");
          onLogin(response.data.role);
        }
      } else {
        setErrorMessage(response.data.message);
      }

      setEmail("");
      setPassword("");
    } catch (error) {
      console.error(error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} />
      <div className="login-image">
        <img src={logo} alt="" />
      </div>
      <div className="login-container">
        <div className="login-card">
          <div className="login-content">
            <form onSubmit={doLogin}>
              <p>Connexion</p>
              <div className="input-container">
                <label htmlFor="email">E-mail</label>
                <input
                  name="email"
                  type="text"
                  placeholder="E-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-container">
                <label htmlFor="password">Mot de passe</label>
                <input
                  name="password"
                  type="password"
                  placeholder="Mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="button-container">
                <button type="submit">S'identifier</button>
              </div>
              <div style={{ textAlign: 'center', marginTop: '0.75rem' }}>
                <Link to="/forgot-password" style={{ color: '#e53935', textDecoration: 'none', fontWeight: 500 }}>
                  Mot de passe oublié ?
                </Link>
              </div>
              {errorMessage && (
                <div className="error-message">{errorMessage}</div>
              )}
            </form>
          </div>
          <div className="account-link">
            <p>
              Vous n'avez pas de compte ?{" "}
              <Link to="/signup">
                <span>S'inscrire</span>
              </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
